import React from "react";
import config from "./config";
import Guide from "./Guide";
import app from "../../app";

import "./GatewayForm.scss";

export const GatewayTool: React.FC<{}> = () => {
  return (
    <>
      <Guide formConfig={config} />
    </>
  );
};

export const GatewayToolApp = app(GatewayTool);
export default GatewayToolApp;
